(function ($, Global) {
    var VeilleFeuilletonComponent = function (veilleModel) {
        this.veilleModel = veilleModel;
    }

    VeilleFeuilletonComponent.prototype.initEvents = function () {
      
        this.publishers();
    }

    VeilleFeuilletonComponent.prototype.publishers = function () {
        $(document).on('click', '.btn-veille-feuilleton', function (e) {
            e.preventDefault();

            if (Global.indigoSso.connected != 1) return $.Topic('signup-modal-show').publish('simple-free', { origin: 'veille' });

            var $btn = $(this);
            var dociid = $btn.data('dociid');
            var termes = $btn.data('termes');

            if (!dociid || !termes) return;

            var data = {
                IsFeuilleton: true,
                Dociid: dociid,
                TermesRecherches: termes
            }
            $.Topic('veille-new').publish(data, function() {})
        });
    }

    Global.VeilleFeuilletonComponent = VeilleFeuilletonComponent;
}(jQuery, window));